import { render, staticRenderFns } from "./Clue.vue?vue&type=template&id=3552641c&scoped=true&"
import script from "./Clue.vue?vue&type=script&lang=js&"
export * from "./Clue.vue?vue&type=script&lang=js&"
import style0 from "./Clue.vue?vue&type=style&index=0&id=3552641c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3552641c",
  null
  
)

export default component.exports